const features = [
  {
    id: 1,
    icon: 'ri-user-smile-line',
    title: '初心者大歓迎',
    description: '包丁の持ち方から丁寧に教えます。料理が初めての方も安心してご参加ください！',
    color: 'bg-gradient-to-br from-orange-400 to-red-400',
    iconBg: 'bg-orange-100',
    iconColor: 'text-orange-600'
  },
  {
    id: 2,
    icon: 'ri-group-line',
    title: '少人数制',
    description: '一人ひとりにしっかり目が届く少人数制。質問もしやすい雰囲気です！',
    color: 'bg-gradient-to-br from-red-400 to-pink-400',
    iconBg: 'bg-red-100',
    iconColor: 'text-red-600'
  },
  {
    id: 3,
    icon: 'ri-calendar-check-line',
    title: '柔軟なスケジュール',
    description: 'お仕事や家事の合間に。あなたの都合に合わせてレッスン日を調整できます！',
    color: 'bg-gradient-to-br from-pink-400 to-purple-400',
    iconBg: 'bg-pink-100',
    iconColor: 'text-pink-600'
  },
  {
    id: 4,
    icon: 'ri-leaf-line',
    title: '旬の食材',
    description: '季節ごとの新鮮な食材を使用。食材の選び方も学べます！',
    color: 'bg-gradient-to-br from-green-400 to-emerald-400',
    iconBg: 'bg-green-100',
    iconColor: 'text-green-600'
  },
  {
    id: 5,
    icon: 'ri-heart-3-line',
    title: '楽しい雰囲気',
    description: '笑顔あふれる明るい教室。料理を通じて新しい仲間もできます！',
    color: 'bg-gradient-to-br from-yellow-400 to-orange-400',
    iconBg: 'bg-yellow-100',
    iconColor: 'text-yellow-600'
  },
  {
    id: 6,
    icon: 'ri-home-smile-line',
    title: 'ご自宅でも',
    description: '訪問型レッスンなら、使い慣れたキッチンで学べます！',
    color: 'bg-gradient-to-br from-blue-400 to-cyan-400',
    iconBg: 'bg-blue-100',
    iconColor: 'text-blue-600'
  }
];

export default function Features() {
  return (
    <section id="features" className="py-24 bg-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23f97316' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }}></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-orange-50 px-5 py-2.5 rounded-full shadow-lg mb-6 border-2 border-orange-300" style={{ borderStyle: 'dashed' }}>
            <i className="ri-star-smile-line text-orange-500"></i>
            <span className="text-orange-600 font-medium" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
              Why Choose Us
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: '"Klee One", cursive' }}>
            シルバー料理教室の特徴
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
            楽しく、美味しく、そして確実に上達できる理由があります！
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={feature.id}
              className="bg-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer border-3 border-gray-100"
              style={{ 
                animationDelay: `${index * 100}ms`,
                borderStyle: 'dashed',
                borderWidth: '3px'
              }}
            >
              <div className={`w-20 h-20 ${feature.iconBg} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-md border-2 border-white`}>
                <i className={`${feature.icon} ${feature.iconColor} text-4xl`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Klee One", cursive' }}>
                {feature.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-gradient-to-r from-orange-400 to-red-400 rounded-3xl p-12 text-center shadow-2xl border-4 border-white relative overflow-hidden" style={{ borderStyle: 'dashed' }}>
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -mr-32 -mt-32"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/10 rounded-full -ml-32 -mb-32"></div>
          
          <div className="relative z-10">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: '"Klee One", cursive' }}>
              まずは体験レッスンから！
            </h3>
            <p className="text-xl text-white/90 mb-8" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
              初回限定の特別価格でお試しいただけます
            </p>
            <button 
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-white text-orange-600 px-10 py-4 rounded-full hover:shadow-xl transition-all whitespace-nowrap cursor-pointer font-bold text-lg shadow-lg"
              style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}
            >
              <i className="ri-gift-line mr-2"></i>
              体験レッスンに申し込む
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
